export type PeriodOption = '1' | '3' | '6' | '12' | 'all';

export const PERIOD_OPTIONS: { value: PeriodOption; label: string }[] = [
  { value: '1', label: '1 mois' },
  { value: '3', label: '3 mois' },
  { value: '6', label: '6 mois' },
  { value: '12', label: '1 an' },
  { value: 'all', label: 'Tout' },
];

function toIsoDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * Fenêtre de N mois se terminant au mois précédent (M-1) : les relevés bancaires arrivent en
 * fin de mois, le mois en cours est donc presque toujours incomplet et fausserait l'indicateur.
 */
export function periodRange(option: PeriodOption): { dateFrom?: string; dateTo?: string } {
  if (option === 'all') return {};
  const now = new Date();
  const endOfPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  const months = Number(option);
  const start = new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth() - (months - 1), 1);
  return { dateFrom: toIsoDate(start), dateTo: toIsoDate(endOfPreviousMonth) };
}
